import React, { useLayoutEffect } from "react";
import { Asset } from "../DefaultLayout/DefaultLayout";
import { gsap } from "gsap";
import { useSwiperSlide } from "swiper/react";
import styles from "./SplitPage.module.scss";
import { AssetParser } from "../AssetParser/AssetParser";

interface ISplitPageProps {
  assetRight: Asset[];
  assetLeft: Asset[];
  backgroundColour: { hex: string };
  firstAssetDelay: number;
  followingAssetsDelay: number;
}

export const SplitPage: React.FC<ISplitPageProps> = (props) => {
  const swiperSlide = useSwiperSlide();
  const {
    assetRight,
    assetLeft,
    backgroundColour,
    firstAssetDelay = 1,
    followingAssetsDelay = 1,
  } = props;
  useLayoutEffect(() => {
    if (swiperSlide.isActive) {
      gsap.to(".image", {
        opacity: 1,
        duration: 1,
        delay: firstAssetDelay,
        stagger: followingAssetsDelay,
      });
    } else if (swiperSlide.isNext && swiperSlide.isPrev) {
      gsap.to(".image", {
        opacity: 0,
        duration: 0.3,
      });
    }
  }, [swiperSlide, firstAssetDelay, followingAssetsDelay]);

  if (swiperSlide.isActive || swiperSlide.isNext || swiperSlide.isPrev) {
    return (
      <div
        className={styles.Background}
        style={
          backgroundColour ? { backgroundColor: backgroundColour.hex } : {}
        }
      >
        {assetLeft[0].asset && swiperSlide.isActive && (
          <AssetParser
            assetOptions={assetLeft[0]}
            className={`image ${styles.asset_left} ${styles.image}`}
            isBackgroundVideo
          />
        )}
        {assetRight[0].asset && swiperSlide.isActive && (
          <AssetParser
            assetOptions={assetRight[0]}
            className={`image ${styles.asset_right} ${styles.image}`}
            isBackgroundVideo
          />
        )}
      </div>
    );
  } else {
    return <></>;
  }
};
